module.exports = __webpack_public_path__ + "static/img/wrap3.42b57834.png";